<template>
  <a
    v-if="url && label"
    @click="registerEvent"
    :href="url"
    :alt="alt"
    :class="{
      'c-btn--primary': buttonType === 'primary',
      'c-btn--secondary': buttonType === 'secondary',
      'c-btn--tertiary': buttonType === 'tertiary',
    }"
    :target="linkTarget"
    class="c-btn c-btn--margins"
    tabindex="0"
  >
    {{ label }}
  </a>
</template>

<script>
export default {
  name: 'LinkButton',
  props: {
    label: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      default: '',
    },
    buttonType: {
      type: String,
      default: 'primary',
    },
    linkTarget: {
      type: String,
      default: '_self',
    },
  },
  computed: {
    slug() {
      return this.$route.params.slug;
    },
    utm_source() {
      return this.$route.query.utm_source;
    },
    utm_medium() {
      return this.$route.query.utm_medium;
    },
    utm_campaign() {
      return this.$route.query.utm_campaign;
    },
    utm_term() {
      return this.$route.query.utm_term;
    },
    utm_content() {
      return this.$route.query.utm_content;
    },
  },
  methods: {
    registerEvent(event) {
      this.$gtag.event(`Knapp: ${this.label} på ${this.slug}`, {
        event_category: 'Button',
        event_label: event,
      });
    },
  },
};
</script>
